import {NoteInvitationCodeSchema} from '../../infra/redux/api/schemata'
import {getById} from '../../infra/redux/api/selectors'

export const getNoteInvitationCodeById = getById(NoteInvitationCodeSchema)
